import React, { useEffect, useState } from 'react';
import './AltHomePage.css';
import '../App.css';
import { Button } from './Button';
import { Link } from 'react-router-dom';
import annivlogo from '../images/2.png';

function AltHomePage() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const prefersReduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    const READY_DELAY = prefersReduce ? 0 : 700;
    let timer;
    const arm = () => {
      timer = window.setTimeout(() => setReady(true), READY_DELAY);
    };
    if (document.readyState === 'complete') {
      arm();
    } else {
      const onLoad = () => {
        arm();
        window.removeEventListener('load', onLoad);
      };
      window.addEventListener('load', onLoad);
      return () => window.removeEventListener('load', onLoad);
    }
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <div className={`alt-hero-container motion ${ready ? 'is-ready' : ''}`}>
      <div className="alt-hero-bg" aria-hidden="true" />
      <div className="alt-hero-inner">
        <div className="alt-hero-copy">
          <p className="alt-hero-subtitle">Celebrating 40 years of Excellence</p>
          <div className="alt-hero-btns">
            <Button to="/history" buttonStyle="btn--outline-middle" buttonSize="btn--large">
              Learn More about DEI
            </Button>
            <Link to="/contact" className="btn btn--outline-middle btn--large no-underline">
              Contact Us
            </Link>
          </div>
        </div>
        <img
          src={annivlogo}
          alt="Dhillon Engineering Inc. — 40th Anniversary"
          className="alt-hero-logo"
        />
      </div>
    </div>
  );
}

export default AltHomePage;
